import { actionTypes, BaseAction } from 'redux/actions';
import { Favorite } from 'bff/models/member';
import { AddFavoriteItem } from 'bff/models/member/addFavoriteItem';

/**
 * @description 取得我的收藏
 */
export const fetchMyFavorite = (memberId:string, addItem?:AddFavoriteItem):BaseAction => {
  return {
    type: actionTypes.MYFAVORITE.FETCH_MY_FAVORITE,
    payload: { MemberId: memberId, AddItem: addItem }
  };
};

/**
 * @description 取得我的收藏完成
 * @param result 我的收藏結果集
 */
export const fetchMyFavoriteComplete = (result:Favorite[]):BaseAction => {
  return {
    type: actionTypes.MYFAVORITE.FETCH_MY_FAVORITE_COMPLETE,
    payload: result
  };
};

/**
 * @description 新增我的收藏
 * @param item 新增我的收藏 Request Model
 */
export const addFavoriteItem = (item:AddFavoriteItem):BaseAction => {
  // console.log('登入新增我的收藏', item);
  return {
    type: actionTypes.MYFAVORITE.ADD_FAVORITE_ITEM,
    payload: item
  };
};

/**
 * @description 移除我的收藏
 * @param sn 推薦/我的收藏方案資料的 SN
 */
export const removeFavoriteItem = (sn:number):BaseAction => {
  // console.log('登入移除我的收藏', sn);
  return {
    type: actionTypes.MYFAVORITE.REMOVE_FAVORITE_ITEM,
    payload: sn
  };
};

/**
 * @description 未登入狀態下，點選新增我的收藏，暫存選項
*/
export const unloginAddItem = (insTypeId: string, prodId: string, planId: string):BaseAction => {
  // console.log('未登入新增我的收藏', `insTypeId: ${insTypeId}, planId: ${planId}, prodId: ${prodId}`);
  return {
    type: actionTypes.MYFAVORITE.UNLOGIN_ADD_FAVORITE_ITEM,
    payload: {
      InsTypeId: insTypeId,
      ProdId: prodId,
      PlanId: planId
    }
  };
};
